import { useEffect, useState } from "react";
import api from "../lib/api";

export function useMenu() {
  const [menu, setMenu] = useState({});
  useEffect(() => {
    api.get("/content/menu").then((r) => setMenu(r.data)).catch(() => {});
  }, []);
  return menu;
}
